import { gql } from '@apollo/client';

export type SavedView = {
  __typename: 'SavedView';
  id: string;
  name: string;
  app: string;
  appVersion?: string;
  viewstate: Record<string, unknown>;
  createdBy: string;
  createdDateTime: string;  // ISO
};

export type SavedViewRole = {
  __typename: 'SavedViewRole';
  savedViewId: string;
  roleId: number;
};

export type SavedViewUser = {
  __typename: 'SavedViewUser';
  savedViewId: string;
  userId: string;
};

export type SavedViewResponse = Pick<SavedView, 'id' | 'name' | 'appVersion' | 'viewstate' | 'createdBy' | 'createdDateTime'> & {
  __typename: 'SavedViewResponse';
  createdByUser: string;
  roles: SavedViewRoleResponse[];
  users: SavedViewUserResponse[];
};

export type SavedViewBaseResponse = Pick<SavedViewResponse, '__typename' | 'id' | 'name'>;
export type SavedViewMetadataResponse = Pick<SavedViewResponse, 'appVersion' | 'createdBy' | 'createdByUser' | 'createdDateTime'>;
export type SavedViewDetailResponse = Pick<SavedViewResponse, 'viewstate'>;
export type SavedViewRelatedResponse = Pick<SavedViewResponse, 'roles' | 'users'>;

export type SavedViewRoleResponse = Pick<SavedViewRole, 'roleId'> & {
  __typename: 'SavedViewRoleResponse';
  role: string;
};

export type SavedViewUserResponse = Pick<SavedViewUser, 'userId'> & {
  __typename: 'SavedViewUserResponse';
  user: string;
};

export type AddSavedViewResponse = Pick<SavedView, 'id'> & {
  __typename: 'AddSavedViewResponse';
};

export const SAVED_VIEW_ROLE_FRAGMENT = gql`
  fragment SavedViewRoleFragment on SavedViewRoleResponse {
    __typename
    roleId
    role
  }
`;

export const SAVED_VIEW_USER_FRAGMENT = gql`
  fragment SavedViewUserFragment on SavedViewUserResponse {
    __typename
    userId
    user
  }
`;

export const SAVED_VIEW_BASE_FRAGMENT = gql`
  fragment SavedViewBaseFragment on SavedViewResponse {
    __typename
    id
    name
  }
`;

export const SAVED_VIEW_METADATA_FRAGMENT = gql`
  fragment SavedViewMetadataFragment on SavedViewResponse {
    appVersion
    createdBy
    createdByUser
    createdDateTime
  }
`;

export const SAVED_VIEW_DETAIL_FRAGMENT = gql`
  fragment SavedViewDetailFragment on SavedViewResponse {
    viewstate
  }
`;

// TODO: Shared Role/User counts (fragment for `RelatedMetadata`?).
export const SAVED_VIEW_RELATED_FRAGMENT = gql`
  fragment SavedViewRelatedFragment on SavedViewResponse {
    roles {
      ...SavedViewRoleFragment
    }
    users {
      ...SavedViewUserFragment
    }
  }
  ${SAVED_VIEW_ROLE_FRAGMENT}
  ${SAVED_VIEW_USER_FRAGMENT}
`;

export const SAVED_VIEW_FRAGMENT = gql`
  fragment SavedViewFragment on SavedViewResponse {
    ...SavedViewBaseFragment
    ...SavedViewMetadataFragment
    ...SavedViewDetailFragment
    ...SavedViewRelatedFragment
  }
  ${SAVED_VIEW_BASE_FRAGMENT}
  ${SAVED_VIEW_DETAIL_FRAGMENT}
  ${SAVED_VIEW_METADATA_FRAGMENT}
  ${SAVED_VIEW_RELATED_FRAGMENT}
`;

export const ADD_SAVED_VIEW_RESPONSE_FRAGMENT = gql`
  fragment AddSavedViewResponseFragment on AddSavedViewResponse {
    __typename
    id
  }
`;
